// §1 Mark: candidate C, "Practical light" (Owner pick, HD-5): the H/F ligature in ink on an accent-tint square,
// one Ember point. Drawn inline from the role tokens so it follows the tier; src/ui/mark.svg and public/favicon.svg
// carry the same geometry for places that need a file. size: 16 | 24 | 32. wordmark adds "Heliconflow" (500).
const LIG = 'M7 8v16M7 16h8M15 8v16M15 8h10M15 16h7';

export default function Mark({ wordmark = false, size = 24 }) {
  return (
    <>
      <svg className="ui ui-mark" width={size} height={size} viewBox="0 0 32 32" role={wordmark ? undefined : 'img'}
        aria-hidden={wordmark || undefined} aria-label={wordmark ? undefined : 'Heliconflow'} focusable="false">
        <rect width="32" height="32" rx="4" className="ui-mark__ground" />
        <path d={LIG} className="ui-mark__lig" strokeWidth={size <= 16 ? 3 : 2.5} strokeLinecap="square" fill="none" />
        <rect x="23" y="20" width="4" height="4" className="ui-mark__light" />
      </svg>
      {wordmark && <span className="ui ui-wordmark">Heliconflow</span>}
    </>
  );
}
